import { lazy } from 'react';

const PreSaleSection = lazy(() => import('../PreSaleSection'));

const PreSaleSectionLazy = () => {
  return <PreSaleSection />;
};

export default PreSaleSectionLazy;
